export default __webpack_public_path__ + "static/media/france.78df1f5f.svg";